import { snake } from 'change-case'
import { HumanErrorMessages, MaxCheckableNumber } from '../../constants'
import { api } from '../../libs/api'
import pagination from './pagination'
import { MySet as Set } from '../../libs/polyfill'

export default {
  namespaced: true,

  modules: {
    pagination: pagination(),
  },

  state: {
    index: [],
    pageIds: [],
    checkedIds: new Set([]),
    pageCheckedIds: new Set([]),
    // 直近の fetchIndex のエラー（成功時は null）。avoidBlank() で使う。
    lastFetchError: null,
  },
  getters: {
    favoredIds: state => new Set(state.index.map(({ id }) => id)),
    favored: (state, getters) => id => getters.favoredIds.has(id),
    checkedCount: state => state.checkedIds.size,
    checked: (_, getters) => getters.checkedCount > 0,
    // eslint-disable-next-line
    pageAllChecked: (state, getters) => getters.checkedCount
      ? !state.pageIds.find(n => !state.pageCheckedIds.has(n))
      : false,
  },
  mutations: {
    index: (state, index) => {
      const pageIds = index.map(({ id }) => id)
      const pageCheckedIds = pageIds.filter(id => state.checkedIds.has(id))

      state.index = index
      state.pageIds = pageIds
      state.pageCheckedIds = new Set(pageCheckedIds)
    },
    check: (state, id) => {
      const newCheckedIds = new Set(state.checkedIds)
      const newPageCheckedIds = new Set(state.pageCheckedIds)
      if (Array.isArray(id)) {
        id.forEach((i) => {
          newCheckedIds.add(i)
          newPageCheckedIds.add(i)
        })
      } else {
        newCheckedIds.add(id)
        newPageCheckedIds.add(id)
      }
      state.checkedIds = newCheckedIds
      state.pageCheckedIds = newPageCheckedIds
    },
    uncheck: (state, id) => {
      const newCheckedIds = new Set(state.checkedIds)
      const newPageCheckedIds = new Set(state.pageCheckedIds)
      if (Array.isArray(id)) {
        id.forEach((i) => {
          newCheckedIds.delete(i)
          newPageCheckedIds.delete(i)
        })
      } else {
        newCheckedIds.delete(id)
        newPageCheckedIds.delete(id)
      }

      state.checkedIds = newCheckedIds
      state.pageCheckedIds = newPageCheckedIds
    },
    uncheckAll: (state) => {
      state.checkedIds.clear()
      state.pageCheckedIds.clear()

      state.checkedIds = new Set(state.checkedIds)
      state.pageCheckedIds = new Set(state.pageCheckedIds)
    },
    update: (state, list) => {
      const index = state.index.find(i => i.listId === list.id)
      if (index) {
        index.sales_status = list.sales_status
        index.sales_status_id = list.sales_status_id
        index.assigned_to = list.assigned_to
        index.assigned_to_id = list.assigned_to_id
        index.updated_by = list.updated_by
        index.updated_at = list.updated_at
        index.created_at = list.created_at
      }
    },
    lastFetchError: (state, error) => state.lastFetchError = error,
  },
  actions: {
    toggleCheck ({ commit, dispatch, state: { checkedIds } }, { checked, id }) {
      if (checked && checkedIds.size >= MaxCheckableNumber) {
        dispatch(
          'common/pushToastError',
          { error: HumanErrorMessages.CHECKED_LIMIT },
          { root: true },
        )
        return
      }

      checked
        ? commit('check', id)
        : commit('uncheck', id)
    },
    togglePageCheck (
      { commit, dispatch, getters: { pageAllChecked }, state: { pageIds, checkedIds } },
      { event }) {
      if (!pageAllChecked) {
        const nextCheckedIds = new Set(checkedIds)
        pageIds.forEach((i) => { nextCheckedIds.add(i) })
        if (nextCheckedIds.size > MaxCheckableNumber) {
          dispatch(
            'common/pushToastError',
            { error: HumanErrorMessages.CHECKED_LIMIT },
            { root: true },
          )
          event.preventDefault()
          return
        }
      }
      pageAllChecked
        ? commit('uncheck', pageIds)
        : commit('check', pageIds)
    },
    updateIndex: ({ commit, state: { index } }, id) => {
      const cloneIndex = []
      index.forEach((job) => { cloneIndex.push(job) })
      const idx = cloneIndex.findIndex(job => job.id === id)
      cloneIndex.splice(idx, 1)
      commit('index', cloneIndex)
    },
    async fetchIndex ({ commit, dispatch }, query) {
      try {
        const requestParameters = Object.keys(query).reduce((acc, key) => {
          acc[snake(key)] = query[key]
          return acc
        }, {})

        const { meta, index: raw } = await api.fetchStartingBusinessList(requestParameters)
        const index = raw.map(i => (
          {
            listId: i.id,
            assigned_to: i.assigned_to,
            assigned_to_id: i.assigned_to_id,
            updated_by: i.updated_by,
            updated_by_id: i.updated_by_id,
            sales_status: i.sales_status,
            sales_status_id: i.sales_status_id,
            created_at: i.created_at,
            updated_at: i.updated_at,
            ...i.starting_business,
            favored: true,
          }
        ))
        commit('pagination/newState', meta)
        commit('index', index)
        commit('lastFetchError', null)
      } catch (e) {
        commit('lastFetchError', e)
        const message = (Array.isArray(e) && e[0] && e[0].message) || HumanErrorMessages.SEARCH_FAILED
        dispatch(
          'common/pushToastError',
          { error: { message } },
          { root: true },
        )
        return Promise.reject(e)
      }
    },
    async add ({ commit }, { id, ids }) {
      await api.addStartingBusinessList({ ids: ids || [id] })
      commit('uncheck', ids || id)
    },
    async remove ({ commit }, { id, ids }) {
      await api.removeStartingBusinessList({ ids: ids || [id] })
      commit('uncheck', ids || id)
    },
    async update ({ commit }, params) {
      const res = await api.updateStartingBusinessList(params)
      const list = await res.data
      commit('update', list)
      commit('startingBusiness/updateStartingBusinessList', list, { root: true })
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/startingBusinessList.js